import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import ArrowImage from 'images/icons/interface-arrow-right.svg';
import { GROUP_MAPPING_DEFAULT_ROWS_SIZE } from '../constants';
import { emptyMapping } from '../helpers';
import { AttributeValueSelect } from './attribute_value_select';
import { GroupSelect } from './group_select';
import { Column, DeleteButton } from './styles';
const rowContainerCss = "r1je77kh";
const RowContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowContainerCss, props.className)} />;
});
const contentColumnCss = "c10neati";
const ContentColumn = forwardRef((props, ref) => <Column ref={ref} {...props} className={classNames(contentColumnCss, props.className)} />);
const arrowImageComponentCss = "a1gg6o3f";
const ArrowImageComponent = forwardRef((props, ref) => <ArrowImage ref={ref} {...props} className={classNames(arrowImageComponentCss, props.className)} />);
export const MappingRow = ({
  index,
  push,
  replace,
  remove,
  autoFocus,
  groupId
}) => {
  const [{
    value: mappings
  }] = useFormField({
    name: 'mappings'
  });
  const [_, {
    error
  }] = useFormField({
    name: `mappings[${index}]`
  });
  const onDelete = () => {
    if (mappings[index].id) {
      const newMapping = {
        ...mappings[index],
        isBeingDeleted: true
      };
      replace(index, newMapping);
    } else {
      remove(index);
    }
    const filteredMappings = mappings.filter(({
      isBeingDeleted: destroy
    }) => !destroy);
    if (filteredMappings.length - 1 < GROUP_MAPPING_DEFAULT_ROWS_SIZE) {
      push(emptyMapping());
    }
  };
  if (mappings[index].isBeingDeleted) return null;
  return <RowContainer role="group">
      <ContentColumn>
        <div>
          <AttributeValueSelect name={`mappings.${index}.attrValue`} autoFocus={autoFocus} aria-label={I18n.t('publisher.organization_settings.user_provisioning.groups.attribute_value.label', {
          index: index + 1
        })} error={error} />
        </div>
        <div>
          <ArrowImageComponent />
        </div>
      </ContentColumn>
      <ContentColumn>
        <div>
          <GroupSelect name={`mappings.${index}.groupId`} groupId={groupId} label={I18n.t('publisher.organization_settings.user_provisioning.groups.calendly_group.label', {
          index: index + 1
        })} error={error} />
        </div>
        <DeleteButton aria-label={I18n.t('publisher.organization_settings.user_provisioning.groups.delete_group_mapping', {
        index: index + 1
      })} onClick={onDelete} />
      </ContentColumn>
    </RowContainer>;
};

require("./mapping_row.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./mapping_row.js");